<template>
  <ActionBar :item="normalizedHolding" @detail="$emit('open')">
    <span @click.stop="trade('buy')">
      <Icon name="arrow-down" />
      <span>{{ $t('trade.order-direction-buy') }}</span>
    </span>
    <span @click.stop="trade('sell')">
      <Icon name="arrow-up" />
      <span>{{ $t('trade.order-direction-sell') }}</span>
    </span>
    <span @click.stop="trade('closeout')">
      <Icon name="bars" />
      <span>{{ $t('trade.closeout') }}</span>
    </span>
  </ActionBar>
</template>
<script>
import ActionBar from 'mod/ActionBar'
import Icon from 'com/Icon'
import moment from 'moment-timezone'
import { SEC_TYPE } from 'const/stock'
import { getQuoteDetail } from 'apis/quote'

export default {
  name: 'Operation',
  components: {
    ActionBar,
    Icon
  },
  props: {
    holding: {
      required: true
    }
  },
  computed: {
    normalizedHolding() {
      if (this.holding.secType === SEC_TYPE.OPT) {
        const expiry = moment
          .tz(this.holding.expiry, 'America/New_York')
          .valueOf()
        return { ...this.holding, expiry }
      } else {
        return this.holding
      }
    }
  },
  methods: {
    trade(type) {
      getQuoteDetail(this.normalizedHolding).then(stock => {
        const tradeRequest = { stock }
        if (type === 'buy') tradeRequest.action = 'BUY'
        if (type === 'sell') tradeRequest.action = 'SELL'
        if (type === 'closeout') {
          tradeRequest.isCloseOut = true
          tradeRequest.holding = this.holding
        }
        this.$store.dispatch('newTradeRequest', tradeRequest)
      })
    }
  }
}
</script>
